import { createContext, useContext } from 'react';

import { ContextType } from './type';

export const DonationCommentActionsContext = createContext<ContextType | null>(
  null
);

export const useDonationCommentContext = () => {
  const context = useContext(DonationCommentActionsContext);
  if (!context) {
    throw new Error(
      'the useDonationCommentContext should be used within a DonationCommentContext.Provider'
    );
  }
  return context;
};
